import { styled } from '@withjoy/joykit/theme';
import ReactSlider from 'react-slider';
import { pxToRem } from '@withjoy/joykit/theme';

interface StyledSliderProps {
  value: [number, number];
  onChange: (value: number | readonly number[], index: number) => void;
  min: number;
  max: number;
  className: string;
  trackClassName: string;
  thumbClassName: string;
}

export const StyledSlider = styled(ReactSlider as React.ComponentType<StyledSliderProps>)(({ theme }) => ({
  width: '100%',
  height: pxToRem(24),
  maxWidth: pxToRem(372),

  '.track': {
    top: '50%',
    transform: 'translateY(-50%)',
    height: pxToRem(4),
    background: theme.colors.mono5,
    borderRadius: pxToRem(2),
  },

  '.track-1': {
    background: theme.colors.newUITest1,
  },

  '.thumb': {
    top: '50%',
    width: pxToRem(24),
    height: pxToRem(24),
    transform: 'translate(0%, -50%)',
    borderRadius: '50%',
    background: theme.colors.white,
    cursor: 'pointer',
    outline: 'none',
    boxShadow: `0 ${pxToRem(3)} ${pxToRem(3)} rgba(0, 0, 0, 0.1)`,

    '&:hover': {
      boxShadow: `0 ${pxToRem(4)} ${pxToRem(4)} rgba(0, 0, 0, 0.2)`,
    },
  },
}));
